module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"Ward_N":"პალატის ნომერი","Beds_Count":"საწოლების რაოდ.","Ward":"პალატა"},"en":{"Ward_N":"Ward N","Beds_Count":"Beds count","Ward":"პალატა"}}')
  delete Component.options._Ctor
}
